import React, { useEffect } from 'react'

import { setErrorSent } from './errorBondarySlice'
import { useAppDispatch, useAppSelector } from '@/client/hooks'
import { clearFilters } from '@/client/workQueuesSlice'
import { useSendSlackNotificationMutation } from '@/services/slackNotification'

const ErrorBoundaryMessage = ({ error }) => {
  const [sendSlackNotification] = useSendSlackNotificationMutation()
  const errorSent = useAppSelector((state) => state.errorBondary.errorSent)
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (error) {
      if (!errorSent) {
        dispatch(setErrorSent(true))
        sendSlackNotification({
          message: `\n:exclamation: *Something went Wrong*\n\n>${error}\n`,
        })
        setErrorSent(true)
      }
    }
  }, [])

  const handleClose = () => {
    dispatch(clearFilters())
    document.location.reload()
  }

  return (
    <div className='absolute -translate-x-1/2 -translate-y-1/2 z-50 top-1/2 left-1/2 bg-white text-center w-1/4 px-4 py-8 rounded-md'>
      <h1 className='tracking-wide font-semibold mb-8'>Oops! Something went wrong</h1>
      <p className='mb-8'>
        We encountered an unexpected error. Please try again later. If the problem persists, please
        contact tech support.
      </p>
      <button
        className='bg-sky-400 text-white px-8 py-4 rounded-md font-bold'
        onClick={handleClose}
      >
        Close
      </button>
    </div>
  )
}

export default ErrorBoundaryMessage
